import { Component, OnInit, AfterViewInit, Inject, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormControl, FormGroup, Validators, FormGroupDirective, NgForm} from '@angular/forms';
import { SharedService } from '../common/shared.service';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';

import { ToastrService } from "ngx-toastr";
import { APP_CONFIG, AppConfig } from '../config/app.config.module';
import { Observable } from 'rxjs/Observable';
import { Http, Response } from '@angular/http';
import { ValidateService } from '../common/validate.service';
import { ISubscription } from 'rxjs/Subscription';
import { TopnavService } from '../header/topnav/topnav.service';
import {ErrorStateMatcher} from '@angular/material/core';

export class StateMatcherValidator implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    return !!(control && control.invalid && (control.dirty || control.touched));
  }
}

/**
 * Author: gomsmaasi
 * 
 * Date Created: March 26th 2018
 * 
 * Description: Component class for Subscription - /subscription
 **/
@Component({
  selector: 'gosg-subscription',
  templateUrl: './subscription.component.html',
  styleUrls: ['./subscription.component.css']
})
export class SubscriptionComponent implements OnInit, AfterViewInit, OnDestroy {
  categoryIds: any;
  subscriptionForm: FormGroup;
  public txtEmail: FormControl;
  public chkAnnounce: FormControl;
  public chkEpart: FormControl;
  public selCategory: FormControl;
  public loading = false;
  public valOthers = '';
  public dataCatId = [];
  dataSubs = [];
  selCategoryVal;
  public matcher: StateMatcherValidator;

  lang = this.lang;
  languageId = this.languageId;
  showNoData = false;
  errormsg = '';
  resetModal;
  showerr = false;
  
  private subscriptionLang: ISubscription;
  private subscriptionFontSize: ISubscription;

  public fontSize: any = {
    "sizeS" : "14px",
    "sizeM" : "19px",
    "sizeL" : "23px",
    "no_styles" : "0.9em"
  };
  
  constructor(
    private router: Router,
    private validateService: ValidateService,
    private sharedService: SharedService,
    private translate: TranslateService,
    private topnavservice: TopnavService,
    private toastr: ToastrService,
    private http: Http,
    @Inject(APP_CONFIG) private config: AppConfig,
  ) {
    this.loading=true;
    this.lang = translate.currentLang;
    //this.languageId = 2;
    this.subscriptionLang = this.translate.onLangChange.subscribe((event: LangChangeEvent) => {

      const myLang = this.translate.currentLang;

      if (myLang === 'en') {
         this.lang = 'en';
         this.languageId = 1;
      }
      if (myLang === 'ms') {
        this.lang = 'ms';
        this.languageId = 2;
      }

      if(this.topnavservice.flagLang){
        this.getAllCategory(this.languageId);
      }
      this.loading = false;

      setTimeout(()=>{
        this.translate.get('pageTitle.home').subscribe((title:string) => {
          title = title + this.translate.instant('home.breadcrumb.subscription');
          this.sharedService.setTitle(title);
        }); 
      },500);

    });

    this.subscriptionFontSize = this.sharedService.fontSizeData.subscribe((data)=>{
      this.fontSize = data;
    });
    this.matcher = new StateMatcherValidator();
  }

  getErrorMessage() {
    return this.txtEmail.hasError('required') ? this.translate.instant('register.err.email') :
        this.txtEmail.hasError('pattern') ? this.translate.instant('register.pattern.email') :
            '';
  }

  ngOnInit() {

    
    if (!this.languageId) {
      if (localStorage.getItem('langID')) {
        this.languageId = localStorage.getItem('langID');
      } else { 
        this.languageId = 1;
      }
    }

    this.txtEmail = new FormControl('', [Validators.required, Validators.pattern(this.validateService.getPattern().email)]);
    this.selCategory = new FormControl();

    this.subscriptionForm = new FormGroup({
      txtEmail: this.txtEmail,
      selCategory: this.selCategory
    });
    this.getAllCategory(this.languageId);
  }

  ngAfterViewInit() {
   
    // Get Title and Sent to GA
    this.translate.get('pageTitle.home').subscribe((title:string) => {
      title = title + this.translate.instant('home.breadcrumb.subscription');
      this.sharedService.setTitleAndGtag(title);
    }); 

    this.sharedService.loadFontSizeData();

  }

  ngOnDestroy() {
    this.subscriptionLang.unsubscribe();
    this.subscriptionFontSize.unsubscribe();
    this.matcher = null;
  }

  getAllCategory(lang: string) {
    this.dataCatId = [];
    this.loading = true;
    return this.sharedService.readPortal('subscription/list', '', '', '', lang)
      .subscribe(rData => {
        this.sharedService.errorHandling(rData, (function () {
          if (rData['subscriptionCategories'].length > 0) {
            this.showNoData = false;
            this.dataSubs = rData['subscriptionCategories'];

            //guna bile change language
            let valCat = this.subscriptionForm.get('selCategory').value;
            if(valCat){//bila category dah ada value
              for(let i=0; i<this.dataSubs.length; i++) {
                if(this.dataSubs[i].categoryCode == valCat[0]){
                  this.selCategoryVal = this.dataSubs[i].categoryName;
                }

                for(let k=0; k<valCat.length; k++) {

                  if(this.dataSubs[i].categoryCode == valCat[k]){
                    this.dataCatId.push(this.dataSubs[i].categoryId);
                  }
                }
              }
            }

            if(this.languageId == 1){
              this.valOthers = 'Others';
            }
            else{
              this.valOthers = 'Lain - lain';
            }
      
          } else {
            this.showNoData = true;
          }
        }).bind(this));
        this.loading = false;
      },
        error => {
          this.sharedService.showError(this.translate.instant('common.err.servicedown'), '');
          this.loading = false;
        });
  }

  chk(eve) {
      this.selCategoryVal = eve.source.triggerValue.split(',')[0];
      this.dataCatId = [];
      let valCat = this.subscriptionForm.get('selCategory').value;

      if(valCat){//bila category dah ada value
        for(let i=0; i<this.dataSubs.length; i++) {
          
          for(let k=0; k<valCat.length; k++) {
            if(this.dataSubs[i].categoryCode == valCat[k]){
              this.dataCatId.push(this.dataSubs[i].categoryId);
            }
          }
        }
      }
  }

  update(formval) {
    
    if(formval.txtEmail && formval.selCategory){
      this.loading = true;
      this.createSubscriptions(formval.txtEmail, formval.selCategory)
      .subscribe(
        data => {
          if(data.statusCode === "SUCCESS"){
            this.sharedService.showSuccess(this.translate.instant('subscription.successMsg'), '');
            this.showerr = false;
          }else if(data.statusCode === "ERROR"){
            this.sharedService.showError(data.statusDesc,'');
            this.showerr = true;
            this.errormsg = data.statusDesc;
          }
          this.loading = false;
        },
        error => {
            this.sharedService.showError(this.translate.instant('common.err.servicedown'), '');
            this.loading = false;
        });
    }
    
  }

  createSubscriptions(emailval, subsval) { //subval dah tak guna sbb value category guna categoryCode bukan category Id.

    let arrCatId = [];
    arrCatId = this.dataCatId;
    
    // if(!this.languageId){
    //   this.languageId = 1;
    // }
    this.languageId = localStorage.getItem('langID');
    this.categoryIds = '';
    arrCatId.forEach((item, index) => {
      this.categoryIds += '&categories='+item;

  });
    return this.http.get(this.config.urlPortal + 'subscription?email=' + emailval+this.categoryIds + '&language='+ this.languageId)
      .map((response: Response) => response.json())
      .retry(5)
      .catch(this.handleError);
  }

  resetMethod(eve){
    this.router.navigate(['index']);
  }

  validateCtrlChk(ctrl: FormControl) {
    // return ctrl.valid || ctrl.untouched
    return this.validateService.validateCtrl(ctrl);
  }

  private handleError(error: Response) {
    let msg = `Status code ${error.status} on url ${error.url}`;
    return Observable.throw(msg);
  }

  }



// WEBPACK FOOTER //
// ./src/app/subscription/subscription.component.ts